

































import {Component, Prop, Vue} from 'vue-property-decorator'
import NewGameDialog from "@/components/round-information/NewGameDialog.vue";

@Component({
    components: {NewGameDialog}
})
export default class RoundHeader extends Vue {

    @Prop()
    activePlayer: string;

    @Prop()
    activeRound: number;

    @Prop()
    guess: boolean;

    private openScoreBoard() {
        this.$emit('open-score-board');
    }

    private openNewGameDialog() {
        this.$emit('open-new-game-dialog')
    }
}
